module.exports = __webpack_public_path__ + "img/viet_logo.ab66f9eb.png";